/**
 * Convert a value to bigint without throwing. Accepts bigint, integer number,
 * or an integer-valued string. Anything else returns the fallback.
 */
export function safeBigInt(value: unknown, fallback: bigint): bigint {
  if (typeof value === 'bigint') {
    return value
  }
  if (typeof value === 'number') {
    return Number.isFinite(value) && Number.isInteger(value)
      ? BigInt(value)
      : fallback
  }
  if (typeof value === 'string' && /^-?\d+$/.test(value)) {
    return BigInt(value)
  }
  return fallback
}
